import type { SlotKey } from '#packages/apilib';
import type { EditorParams } from '.';

export const EditorParamsApiKey: SlotKey<EditorParams> = {
  name: 'EditorParamsApi',
  public: true,
};
